import { makeStyles } from "@material-ui/core"
import { ArrayInput, FormTab, ReferenceInput, SelectInput, SimpleFormIterator, TextInput } from "react-admin"
import { MediaField } from "../../components/mediaField"
import * as React from "react";

const useStyles = makeStyles({
	textarea: {
		width: "25%"
	},
	hidden: {
		display: "none"
	}
})

export const RecapTimeoverMessages = (props) => {
	const classes = useStyles()

	return (
		<FormTab label="Time Over Messages" {...props}>
			<ArrayInput name="timeoverMessages" source="timeoverMessages">
				<SimpleFormIterator disableReordering>
					<TextInput
						className={classes.hidden}
						disabled
						source="id"
						label="Id du message"
					/>
					<TextInput
						className={classes.textarea}
						multiline
						rows="5"
						source="content"
						label="Text du message"
					/>
					<MediaField
						source="mediaContent"
						label="media"
						className={classes.textarea}
						creditClassname={classes.textarea}
						creditSource="credit"
						creditLabel="Crédit de l'image"
						altClassname={classes.textarea}
						altSource="alt"
						altLabel="Alt de l'image"
					/>
					<ReferenceInput
						source="character.id"
						reference="characters"
						label="Personnage"
						className={classes.textarea}
					>
						<SelectInput optionText="name" />
					</ReferenceInput>
				</SimpleFormIterator>
			</ArrayInput>
		</FormTab>
	)
}
